import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import AccountForm from "@/shared/components/account/AccountForm";
import { useTranslation } from "react-i18next";
import TextNotificationsModal from "@/shared/components/account/TextNotificationsModal";
import { getUser } from "@/services/program/getUser";
import {hasSmsablePhoneNumber} from '@/shared/helpers'

const ManagerAccountIndex = ({ auth, program, organization }) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  let [user, setUser] = useState(null);

  useEffect(() => {
    if (auth && organization && program) {
      getUser(organization.id, program.id, auth.id).then((payload) => {
        setUser(payload);
      });
    }
  }, [organization, program, auth]);

  // useEffect(() => {
  //   user && setOpen( !hasSmsablePhoneNumber(user) ? true : false)
  // }, [user])

    useEffect(() => {
    if (user) {
      const shouldOpen =
        !user.phone_notifications && !hasSmsablePhoneNumber(user);

      setOpen(shouldOpen);
    }
  }, [user]);

  const toggle = () => {
    setOpen((prevState) => !prevState);
  };

  if (!auth || !program || !organization || !user) return t("loading");

  return (
    <div className="team">
      <Container>
        <Row className="mt-4">
          <Col md={10}>
            <AccountForm {...{ toggle, user }} />
          </Col>
        </Row>
        <TextNotificationsModal {...{ isOpen, toggle, user }} />
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    program: state.program,
    organization: state.organization,
  };
};

export default connect(mapStateToProps)(ManagerAccountIndex);
